import * as Yup from 'yup';

export const zipUSValidation = Yup.string()
  .required('Postal code is required')
  .matches(/^[0-9]{5}(?:-[0-9]{4})?$/, 'Not a valid U.S. postal code');

export const zipCanadaValidation = Yup.string()
  .required('Postal code is required')
  .matches(
    /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/,
    'Not a valid Canadian postal code'
  );
